module.exports = __webpack_public_path__ + "fonts/TatrabankaSansV1-0-Regular.32f53b59.woff";